import React from 'react'
import PageTemplate, { BodyContainer, TemplateContainer } from './PageTemplate'
import LoadingOverlay from '../LoadingOverlay'
import { Header } from '../Header'
import { CommonFooter } from './Footer'
import { useSelector } from 'react-redux'
import { RootState } from 'src/store/store'

export const AuthorizedPageLoading = () => {
  return (
    <PageTemplate>
      <div>
        <LoadingOverlay isLoading />
      </div>
    </PageTemplate>
  )
}

export const PageLoading = () => {
  const user = useSelector((state: RootState) => state.login?.user)

  return (
    <TemplateContainer>
      <Header />
      <BodyContainer id={'loading-container'}>
        <div>
          <LoadingOverlay isLoading />
        </div>
      </BodyContainer>
      {!user ? <CommonFooter footerColor="#FFFFFF" /> : <CommonFooter />}
    </TemplateContainer>
  )
}
